import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetomumbaicab() {



  const cardData = {
    keyword: " Pune to Mumbai Cabs ",



    "headingDescription": "Trustline Cab provides reliable and affordable Pune to Mumbai cab services with comfortable vehicles, professional chauffeurs, and 24/7 customer support. Whether you are traveling for business meetings, airport transfers, family vacations, corporate travel, or one-way outstation trips, we ensure a safe, punctual, and hassle-free journey. Our well-maintained fleet includes AC Sedans, SUVs, Innova Crysta, Ertiga, Tempo Travellers, and luxury cars to suit every travel requirement and budget. We offer transparent pricing, easy online booking, doorstep pickup, and experienced drivers who prioritize your safety and comfort. Choose Trustline Travels for a smooth Pune to Mumbai taxi service with dependable service, flexible travel options, and no hidden charges.",

   "topPlaces": [
   {
    "title": "Bandra",
    "description": "Bandra is one of Mumbai's most popular neighborhoods, known for Bandra Bandstand, Bandra Fort, lively cafes, shopping streets, restaurants, and its vibrant connection to Mumbai's entertainment and business districts."
  },
  {
    "title": "Andheri",
    "description": "Andheri is a major commercial and residential area of Mumbai with excellent connectivity to Mumbai Airport, business hubs, shopping destinations, hotels, restaurants, and entertainment areas."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai's most visited beaches, offering beautiful sunsets, local street food, seaside walks, and a lively atmosphere for families and tourists."
  },
  {
    "title": "Gateway of India",
    "description": "One of Mumbai's most iconic landmarks, Gateway of India overlooks the Arabian Sea and attracts visitors with its historic architecture, scenic waterfront, and ferry rides to Elephanta Caves."
  },
  {
    "title": "Marine Drive",
    "description": "Known as the Queen's Necklace, Marine Drive is a beautiful seaside promenade where visitors enjoy stunning sunset views, evening walks, and the vibrant atmosphere of South Mumbai."
  },
 
  {
    "title": "Colaba",
    "description": "Colaba is a popular South Mumbai destination known for the Gateway of India, Colaba Causeway, historic buildings, restaurants, cafes, and shopping, making it a favorite area for tourists."
  },
  {
    "title": "Elephanta Caves",
    "description": "A UNESCO World Heritage Site, Elephanta Caves is famous for its ancient rock-cut temples dedicated to Lord Shiva and is easily accessible by ferry from the Gateway of India."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "Dedicated to Lord Ganesha, Siddhivinayak Temple is among Mumbai's most revered religious destinations and attracts devotees from across India throughout the year."
  },
  {
    "title": "Worli",
    "description": "Worli is a prominent Mumbai neighborhood known for the Bandra-Worli Sea Link, Arabian Sea views, Worli Sea Face, luxury residences, restaurants, and its convenient connection between South Mumbai and the western suburbs."
  },
  {
    "title": "Powai",
    "description": "Powai is a modern Mumbai neighborhood centered around Powai Lake and surrounded by business parks, hotels, restaurants, residential communities, and recreational spaces."
  },
  {
    "title": "Lower Parel",
    "description": "Lower Parel is a major commercial and lifestyle destination in Mumbai, known for corporate offices, luxury malls, restaurants, hotels, and popular entertainment venues."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Sanjay Gandhi National Park is a large green space within Mumbai offering nature trails, wildlife experiences, boating, and access to the historic Kanheri Caves."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is one of Mumbai's most impressive architectural landmarks, combining Victorian Gothic architecture with Indian influences."
  }
],





    "services": [
      {
        "name": "Pune Mumbai Cab",
        "description": "Book Pune Mumbai cab service for safe, comfortable, and affordable intercity travel. Covering approximately 150 km via the Mumbai-Pune Expressway, our cab service is ideal for business travelers, families, airport transfers, and tourists. Choose from Sedan, Ertiga, Innova Crysta, and SUV vehicles with professional chauffeurs, doorstep pickup, and transparent pricing for a smooth journey."
      },
      {
        "name": "Mumbai to Pune Taxi",
        "description": "Reliable Mumbai to Pune taxi service with one-way and round-trip options. Enjoy clean AC vehicles, experienced drivers, and 24/7 availability for airport transfers, corporate travel, family trips, and weekend journeys. Flexible pickup from Mumbai city, airports, hotels, and railway stations ensures a hassle-free experience."
      },
      {
        "name": "Pune to Mumbai Cheapest Cab",
        "description": "Travel with the cheapest Pune to Mumbai cab without compromising comfort or safety. Budget-friendly fare plans, transparent pricing, and well-maintained vehicles make this service ideal for students, solo travelers, families, and daily commuters looking for economical intercity transportation."
      },
      {
        "name": "Pune to Mumbai Cab Service",
        "description": "Professional Pune to Mumbai cab service offering one-way, round-trip, airport transfer, and outstation travel. Our fleet includes Sedan, Ertiga, Innova Crysta, and SUVs driven by experienced chauffeurs who ensure punctual pickups and comfortable travel on the Mumbai-Pune Expressway."
      },
      {
        "name": "Pune to Mumbai Cab Fare",
        "description": "Get transparent Pune to Mumbai cab fare with no hidden charges. Pricing depends on vehicle type, travel schedule, tolls, and trip requirements. Affordable fare options help travelers choose the best cab according to their budget and travel preferences."
      },
      {
        "name": "Pune Mumbai Taxi Service",
        "description": "Book Pune Mumbai taxi service for comfortable intercity transportation. Whether you're traveling for business meetings, vacations, airport transfers, or family visits, our private taxi service offers reliable vehicles, experienced drivers, and flexible travel timings."
      },
      {
        "name": "Pune to Mumbai Cab Booking",
        "description": "Book Pune to Mumbai cab online with instant confirmation and multiple vehicle choices. Advance booking guarantees timely pickup, professional chauffeur service, and convenient transportation from your home, hotel, office, railway station, or airport."
      },
      {
        "name": "Pune Mumbai Cab Rental",
        "description": "Choose Pune Mumbai cab rental for flexible travel with hourly, one-way, round-trip, and multi-day rental options. Well-maintained vehicles and customized packages make the service suitable for business travelers, families, and tourists."
      },
      {
        "name": "Pune Mumbai Pune Car Rental",
        "description": "Book Pune Mumbai Pune car rental for same-day return trips, business meetings, corporate travel, and sightseeing. Flexible return timings, comfortable vehicles, and experienced drivers ensure a stress-free round-trip experience."
      },
      {
        "name": "Pune Mumbai Taxi Price",
        "description": "Check Pune Mumbai taxi price for Sedan, Ertiga, Innova Crysta, and SUV vehicles with transparent pricing and affordable travel packages. Our fare includes comfortable transportation, professional drivers, and reliable service without hidden costs."
      },
      {
        "name": "Pune Mumbai Car Rental",
        "description": "Pune Mumbai car rental service offers private transportation for business travel, airport transfers, family vacations, and corporate requirements. Select from a wide fleet of vehicles with flexible booking options and experienced chauffeurs."
      },
      {
        "name": "Pune to Mumbai Ertiga Cab",
        "description": "Book Pune to Mumbai Ertiga cab for comfortable travel with up to six passengers. Spacious seating, generous luggage space, and air-conditioned interiors make Ertiga an ideal choice for families and small groups traveling between Pune and Mumbai."
      },
      {
        "name": "Pune to Mumbai Innova Cab",
        "description": "Premium Pune to Mumbai Innova cab service provides luxurious seating, superior comfort, and extra luggage capacity. Ideal for corporate executives, families, and group travel, the Innova ensures a relaxing journey on the expressway."
      },
      {
        "name": "Pune to Mumbai Innova Crysta",
        "description": "Travel in luxury with Pune to Mumbai Innova Crysta service featuring spacious interiors, premium seating, and modern amenities. The vehicle is perfect for airport transfers, VIP travel, family trips, and long-distance journeys."
      },
      {
        "name": "Pune Mumbai Innova Rental",
        "description": "Book Pune Mumbai Innova rental for comfortable one-way, round-trip, or multi-day travel. Spacious seating, experienced chauffeurs, and premium interiors make it suitable for business travel, family vacations, and outstation trips."
      },
      {
        "name": "Pune to Mumbai International Airport Cab",
        "description": "Reliable Pune to Mumbai International Airport cab service with direct transfers to Chhatrapati Shivaji Maharaj International Airport. Enjoy timely pickups, flight tracking, luggage assistance, and professional drivers for stress-free airport transportation."
      },
      {
        "name": "Pune to Mumbai Velocity Cabs",
        "description": "Choose Pune to Mumbai Velocity Cabs for dependable intercity travel with clean vehicles, experienced drivers, and affordable pricing. Suitable for corporate travel, airport transfers, and family journeys with flexible scheduling options."
      },
      {
        "name": "Pune to Mumbai Taxi",
        "description": "Book Pune to Mumbai taxi service for comfortable and convenient travel any time of the day. Available for one-way trips, return journeys, airport transfers, and outstation travel with well-maintained AC vehicles and courteous chauffeurs."
      },
      {
        "name": "Pune to Mumbai Airport Cab",
        "description": "Pune to Mumbai Airport cab service provides direct transportation to both domestic and international terminals with punctual pickups, flight monitoring, and comfortable travel. Ideal for business travelers, families, and tourists."
      },
      {
        "name": "Cheap Pune to Mumbai Cab",
        "description": "Book cheap Pune to Mumbai cab and enjoy affordable travel with reliable service, transparent pricing, and comfortable AC vehicles. Perfect for students, professionals, families, and tourists looking for budget-friendly transportation between Pune and Mumbai."
      },
      {
        "name": "Pune to Mumbai Outstation Cab",
        "description": "Pune to Mumbai outstation cab service offers flexible one-way, round-trip, and customized travel packages. Choose from Sedan, Ertiga, Innova Crysta, and SUV vehicles with professional drivers for safe, comfortable, and reliable intercity transportation."
      }
    ],

    "tableData": [
      ["Pune Mumbai Cab", "Mumbai to Pune Taxi"],
      ["Pune to Mumbai Cheapest Cab", "Pune to Mumbai Cab Service"],
      ["Pune to Mumbai Cab Fare", "Pune Mumbai Taxi Service"],
      ["Pune to Mumbai Cab Booking", "Pune Mumbai Cab Rental"],
      ["Pune Mumbai Pune Car Rental", "Pune Mumbai Taxi Price"],
      ["Pune Mumbai Car Rental", "Pune to Mumbai Ertiga Cab"],
      ["Pune to Mumbai Innova Cab", "Pune to Mumbai Innova Crysta"],
      ["Pune Mumbai Innova Rental", "Pune to Mumbai International Airport Cab"],
      ["Pune to Mumbai Velocity Cabs", "Pune to Mumbai Taxi"],
      ["Pune to Mumbai Airport Cab", "Cheap Pune to Mumbai Cab"],
      ["Pune to Mumbai Outstation Cab", "Pune to Mumbai Cab Booking"]
    ],






    whychoose: [
      {
        WhyChooseheading: "Reliable Pune to Mumbai Cab Service",
        WhyChoosedescription: "Trustline Cab offers dependable Pune to Mumbai cab services with comfortable vehicles for business trips, airport transfers, and family travel."
      },
      {
        WhyChooseheading: "One Way & Round Trip Booking",
        WhyChoosedescription: "Book flexible one-way or round-trip cabs based on your travel schedule with quick confirmation."
      },
      {
        WhyChooseheading: "Professional Highway Drivers",
        WhyChoosedescription: "Experienced chauffeurs ensure a safe, smooth, and timely journey via the Mumbai-Pune Expressway."
      },
      {
        WhyChooseheading: "Transparent Fare Structure",
        WhyChoosedescription: "Receive clear fare details before booking with absolutely no hidden charges or surprise costs."
      },
      {
        WhyChooseheading: "Comfortable & Sanitized Vehicles",
        WhyChoosedescription: "Travel in clean, air-conditioned, and regularly maintained cabs for a pleasant intercity experience."
      },
      {
        WhyChooseheading: "Pickup from Any Location in Pune",
        WhyChoosedescription: "We provide doorstep pickup from homes, hotels, offices, railway stations, and Pune Airport."
      },
      {
        WhyChooseheading: "Fleet for Every Travel Need",
        WhyChoosedescription: "Choose from Sedan, Ertiga, Innova, Innova Crysta, and Tempo Traveller according to your group size."
      },
      {
        WhyChooseheading: "Dedicated Customer Support",
        WhyChoosedescription: "Our booking team is available to assist you with reservations, fare details, and travel planning."
      }
    ]

  };

  const faqData = [
    {
      question: "Does Trustline Cab provide Pune to Mumbai cab service?",
      answer: "Yes, Trustline Cab offers reliable Pune to Mumbai cab services for one-way trips, round trips, airport transfers, and corporate travel."
    },
    {
      question: "Can I book a one-way cab from Pune to Mumbai?",
      answer: "Yes, we provide affordable one-way cab services with comfortable vehicles and experienced drivers."
    },
    {
      question: "Which vehicles are available for Pune to Mumbai travel?",
      answer: "You can book Sedan, Ertiga, Innova, Innova Crysta, SUVs, and Tempo Travellers according to your travel requirements."
    },
    {
      question: "Do you provide Mumbai Airport drop service?",
      answer: "Yes, we provide airport drop and pickup services for both Terminal 1 and Terminal 2 of Mumbai Airport."
    },
    {
      question: "How long does it take to reach Mumbai from Pune?",
      answer: "The journey generally takes around 3 to 4 hours depending on traffic and your destination within Mumbai."
    },
    {
      question: "Are toll and parking charges included in the fare?",
      answer: "Toll, parking, and applicable taxes are usually charged separately unless included in your quotation."
    },
    {
      question: "Is the cab service available throughout the day?",
      answer: "Yes, Trustline Cab provides Pune to Mumbai cab services 24 hours a day for customer convenience."
    },
    {
      question: "Can I reserve my cab in advance?",
      answer: "Yes, advance booking is recommended to secure your preferred vehicle and pickup time."
    },
    {
      question: "Do you provide cabs for corporate travel?",
      answer: "Yes, we regularly serve corporate clients traveling between Pune and Mumbai for meetings and business events."
    },
    {
      question: "How can I book a Pune to Mumbai cab?",
      answer: "Simply contact Trustline Travels with your pickup location, travel date, and preferred vehicle to receive an instant quotation."
    }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Amit Kulkarni",
      feedback: "Trustline Travels made my Pune to Mumbai business trip extremely convenient. The driver arrived on time, the cab was spotless, and the entire journey was comfortable from start to finish.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Priyanka Joshi",
      feedback: "Our family traveled from Pune to Mumbai in an Innova Crysta, and the experience was excellent. The booking process was simple, the ride was smooth, and the service exceeded our expectations.",
      rating: 5
    }
  ];
















  const Images = [
    { place: "/images/keyword/29.jpeg", text: "Pune to Mumbai Cabs", link: "Pune-to-Mumbai-Cabs" },
    { place: "/images/keyword/30.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/31.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
    { place: "/images/keyword/32.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
    { place: "/images/keyword/33.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
    { place: "/images/keyword/34.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
    { place: "/images/keyword/35.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
    { place: "/images/keyword/36.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
    { place: "/images/keyword/37.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
    { place: "/images/keyword/38.jpg", text: "Hinjewadi to Mumbai Cabs", link: "Hinjewadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/39.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/40.jpg", text: "Wakad to Mumbai Cabs", link: "Wakad-to-Mumbai-Cabs" },
    { place: "/images/keyword/41.jpg", text: "Hadapsar to Mumbai Cabs", link: "Hadapsar-to-Mumbai-Cabs" },
    { place: "/images/keyword/42.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
    { place: "/images/keyword/43.jpg", text: "Koregaon Park to Mumbai Cabs", link: "Koregaon-Park-to-Mumbai-Cabs" },
    { place: "/images/keyword/44.jpg", text: "Kothrud to Mumbai Cabs", link: "Kothrud-to-Mumbai-Cabs" },
    { place: "/images/keyword/45.jpg", text: "Kharadi to Mumbai Cabs", link: "Kharadi-to-Mumbai-Cabs" },
    { place: "/images/keyword/46.jpg", text: "Shivajinagar to Mumbai Cabs", link: "Shivajinagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/47.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
    { place: "/images/keyword/48.jpg", text: "Pune to Mumbai Innova Crysta Cabs", link: "Pune-to-Mumbai-Innova-Crysta-Cabs" },
    { place: "/images/keyword/49.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
    { place: "/images/keyword/50.jpg", text: "Kondhwa to Mumbai Cabs", link: "Kondhwa-to-Mumbai-Cabs" },
    { place: "/images/keyword/51.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
    { place: "/images/keyword/52.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
    { place: "/images/keyword/53.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
    { place: "/images/keyword/54.jpg", text: "Boat Club Road to Mumbai Cabs", link: "Boat-Club-Road-to-Mumbai-Cabs" },
    { place: "/images/keyword/55.jpg", text: "Vishrantwadi to Mumbai Cabs", link: "Vishrantwadi-to-Mumbai-Cabs" },
];










const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Mumbai Cab Service",
  "image": "https://www.trustlinetravels.com/assets/images/pune-to-mumbai-cab.webp",
  "description": "Book Pune to Mumbai cab service for safe, comfortable, and affordable intercity travel. Trustline Travels offers one-way and round-trip taxi booking with Sedan, SUV, Ertiga, Innova, and luxury cab options available 24x7.",
  "brand": {
    "@type": "Brand",
    "name": "Trustline Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.trustlinetravels.com/pune-to-mumbai-cab"
  }
};




  return (
    <div>


<Helmet>
  <title>Pune to Mumbai Cab Service | Affordable Taxi Booking | +91 8087080034</title>

  <meta
    name="description"
    content="Book Pune to Mumbai cab service for one-way and round-trip travel at affordable fares. Trustline Travels provides Sedan, SUV, Ertiga, Innova, and luxury taxi services with professional drivers, 24x7 availability, and comfortable intercity rides."
  />

  <meta
    name="keywords"
    content="pune mumbai cab, mumbai to pune taxi, pune to mumbai cheapest cab, pune to mumbai cab service, pune to mumbai cab fare, pune mumbai taxi service, pune to mumbai cab booking, pune mumbai cab rental, pune mumbai pune car rental, pune mumbai taxi price, Pune Mumbai car rental, pune to mumbai ertiga cab, Pune to Mumbai Cab, pune to mumbai taxi, cab from pune to mumbai, taxi from pune to mumbai, one way pune to mumbai cab, round trip pune mumbai taxi, best pune to mumbai cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
  className="wt-bnr-inr site-bg-dark twm-primary-overlay-wrap"
  style={{
    backgroundImage:
      "linear-gradient(90deg, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.75) 50%, rgba(0,0,0,0.75) 100%), url('/images/banner-10.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
        <div className="twm-primary-overlay"></div>

        <div className="container">
          <div className="wt-bnr-inr-entry">
            <div className="banner-title-ouer">
              <div className="banner-title-name">
                <h2 className="wt-title">{cardData.keyword}</h2>
              </div>
            </div>
          </div>
        </div>
      </div>
















      <section>
        <div className="container-fluid pdfing" >
          <div className="row container-fluid pdfing">
            <div className="col-12 col-md-7 bg-foootr p-0">
              <img src='/images/keyword/29.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Trustline Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              {/* <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                  
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div> */}


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              {/* <div id="why-choose-section" className="why-choose-section">


                
                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

               
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div> */}


              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-white">
                  Why Choose <span>Trustline Cab</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Trustline Cab</h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918087080034 " className="pc-call">+91 8087080034 </a>
                      <a href="tel:+919421185217" className="pc-call">+91 9421185217</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918087080034 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+918087080034 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@trustlinetravels.com" className="pc-email">
                      booking@trustlinetravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Trustline Travels</strong><br />
                      Office  No 3 ,Shive Pride, Lane No 14,
                      Swami Samarth Nagar, Sathe Nagar,
                      Lohegaon, Pune, Maharashtra-411047.



                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetomumbaicab;